import React, { useState } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { Collection } from '@components/common';
import './AllBorrowingsPage.scss';

export const AllBorrowingsPage = () => {
    const { t } = useTranslation();

    return (
        <div className="all-borrowings-page">
            <Collection
                modelName="borrowings"
                endpoint="getAll"
                sortFields={[
                    { key: 'borrowed_at', label: t('borrowing.borrowed_date') },
                    { key: 'expected_return_at', label: t('borrowing.expected_return') },
                    { key: 'returned_at', label: t('borrowing.returned_date') }
                ]}
                // filterOptions will be auto-populated from modelFilters config
            />
        </div>
    );
};

export default AllBorrowingsPage;
